import * as React from 'react';
import { Chip, useTheme } from '@mui/material';
import { useTranslate, useRecordContext } from 'react-admin';
import { Order } from '../types';
import { statuses } from './orderStatus';

// Custom styling for specific statuses
const getCustomStyle = (statusKey: string, isDarkMode: boolean) => {
    if (statusKey === 'VERIFICATION_IN_PROGRESS') {
        return {
            backgroundColor: isDarkMode ? '#ba68c8' : '#9c27b0', // Purple color (lighter for dark mode)
            color: '#fff',
        };
    }
    
    if (statusKey === 'ON_HOLD') {
        return {
            backgroundColor: isDarkMode ? '#ffb74d' : '#ff9800', // Orange color (lighter for dark mode)
            color: '#fff',
        };
    }
    
    return {};
};

const StatusColumn = () => {
    const translate = useTranslate();
    const record = useRecordContext<Order>();
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    
    if (!record) {
        return null;
    }

    const status = statuses[record.status];
    const customStyle = getCustomStyle(status.key, isDarkMode);

    return (
        <Chip
            color={status.color}
            size="small"
            key={status.id}
            label={translate(status.translationKey)}
            sx={customStyle}
        />
    );
};

export default StatusColumn;
